import React from "react";
import ReactDOM from "react-dom";
import { confirmBtn, error_image, logout } from "../../../utils/index";
import Countdown from "react-countdown";
import WarningAmberIcon from "@mui/icons-material/WarningAmber";
import Swal from "sweetalert2";

function IdleTimerPopup({ openModal, closeModal }) {
    const renderer = ({ minutes, seconds, completed }) => {
        if (completed) {
            // after 5 minutes, if the user does not take any action ==> LOGOUT
            closeModal();

            sessionStorage.clear();
            localStorage.clear();

            Swal.fire({
                imageUrl: error_image,
                imageHeight: 66,
                title: "Session expired",
                text: "Your session is expired. Please re-login.",
                allowEscapeKey: false,
                allowOutsideClick: false,
                customClass: {
                    confirmButton: confirmBtn,
                },
            }).then((res) => {
                if (res.isConfirmed) {
                    logout();
                }
            });
            return <></>;
        } else {
            return (
                <span>
                    {minutes}:{seconds}
                </span>
            );
        }
    };

    return ReactDOM.createPortal(
        <>
            <div
                className={`sdp-modal${
                    openModal ? " active" : ""
                } px-4 py-3 border-0 border-radius-8`}
                style={{
                    width: "400px",
                    height: "auto",
                }}
            >
                <div className="sdp-modal-header bg-white height-auto flex-column align-items-center">
                    <WarningAmberIcon
                        fontSize="large"
                        style={{ color: "#f8bb86", marginRight: 5 }}
                    />
                    <h2 className="fs-5 flex-row-center-center">
                        Session is about to expire
                    </h2>
                </div>
                <div className="sdp-modal-body text-center py-3">
                    <div>
                        You have been away! Your session ends in{" "}
                        <Countdown
                            date={Date.now() + 5 * 60 * 1000}
                            renderer={renderer}
                        />
                        .
                    </div>
                    <div>Do you want to stay logged in?</div>
                </div>
                <div className="sdp-modal-footer height-auto flex-row-center-center gap-3 pt-3">
                    <button
                        className="btn primary-btn px-3 py-2"
                        onClick={closeModal}
                    >
                        Still here
                    </button>
                    <button
                        className="btn secondary-btn px-3 py-2"
                        onClick={() => logout()}
                    >
                        Log out
                    </button>
                </div>
            </div>
            <div className={`sdp-modal-overlay${openModal && " active"}`}></div>
        </>,
        document.getElementById("portal")
    );
}

export default IdleTimerPopup;
